import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { useToast } from '../hooks/use-toast';

// Tasto indietro di Android: un tocco torna alla schermata precedente,
// due tocchi entro 2 secondi sulla Home escono dall'app.
// Senza questo, il tasto indietro chiude l'app da qualunque schermata.

// Da quale schermata si torna a quale. null = siamo alla radice.
const parentOf = (pathname) => {
  if (pathname.startsWith('/vehicles')) return '/';
  if (pathname === '/history' || pathname === '/settings') return '/';
  return null;
};

const DOUBLE_TAP_MS = 2000;

const BackButtonHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const lastPressRef = useRef(0);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    let handle;
    let cancelled = false;

    CapacitorApp.addListener('backButton', () => {
      const parent = parentOf(location.pathname);

      if (parent) {
        lastPressRef.current = 0; // non siamo alla radice: azzera il conteggio uscita
        navigate(parent);
        return;
      }

      const now = Date.now();
      if (now - lastPressRef.current < DOUBLE_TAP_MS) {
        CapacitorApp.exitApp();
        return;
      }
      lastPressRef.current = now;
      toast({ title: 'Premi ancora per uscire' });
    }).then((h) => {
      // Se il componente è già stato smontato, stacca subito il listener
      if (cancelled) h.remove();
      else handle = h;
    });

    return () => {
      cancelled = true;
      if (handle) handle.remove();
    };
  }, [location.pathname, navigate, toast]);

  return null;
};

export default BackButtonHandler;
